import TripsHomeView from "@/views/TripsHomeView.vue";
import {
  createRouter,
  createWebHistory,
  type RouteRecordRaw,
} from "vue-router";

const routeNames = [
  "home",
  "trip-add-destination",
  "trip-add-origin",
  "trip-add-details",
  "trip-itinerary",
  "trip-stats",
] as const;

export type RouteName = (typeof routeNames)[number];

const baseRoutes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "home" satisfies RouteName,
    component: TripsHomeView,
  },
  {
    path: "/login/location=:location(.*)?",
    component: () => import("@/views/ReturningAuthView.vue"),
    meta: {
      section: "utility",
    },
  },
  {
    // Fallback for a bare /login with no location= wrapper (e.g. a stale
    // bookmark, or anything not generated by auth.ts's getRedirectUri).
    // Must come after the more specific /login/location=... route above -
    // vue-router matches in list order, so the specific route needs first
    // refusal before this one catches everything else under /login.
    path: "/login/:pathMatch(.*)*",
    component: () => import("@/views/ReturningAuthView.vue"),
    meta: {
      section: "utility",
    },
  },
];

const tripPlanningRoutes: RouteRecordRaw[] = [
  {
    path: "/trip/planning",
    children: [
      {
        path: "add-destination",
        name: "trip-add-destination",
        component: () => import("@/views/PlanningAddDestinationView.vue"),
        meta: {
          section: "trip",
          breadcrumbMode: "trip",
        },
      },
      {
        path: "add-origin",
        name: "trip-add-origin",
        component: () => import("@/views/PlanningAddOriginView.vue"),
        meta: {
          section: "trip",
          breadcrumbMode: "trip",
        },
      },
      {
        path: "add-details",
        name: "trip-add-details",
        component: () => import("@/views/PlanningAddDetailsView.vue"),
        meta: {
          section: "trip",
        },
      },
      {
        path: "itinerary",
        name: "trip-itinerary",
        component: () => import("@/views/PlanningItineraryView.vue"),
        meta: {
          section: "trip",
        },
      },
      {
        path: "stats",
        name: "trip-stats",
        component: () => import("@/views/TripStatsView.vue"),
        meta: {
          section: "trip",
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    ...baseRoutes,
    ...tripPlanningRoutes,
    {
      path: "/:pathMatch(.*)*", // always end with catch all
      component: () => import("@/views/PageNoteFoundView.vue"),
    },
  ],
});

export default router;
